import styled from '@emotion/styled';
import { SPACER, primaryTheme } from 'radiance-ui/lib/constants';

export const UnorderedList = styled.ol`
  padding-left: ${SPACER.xlarge};
  list-style-type: disc;
`;

export const InlinePre = styled.pre`
  display: inline;
  background-color: ${primaryTheme.COLORS.infoLight};
  padding: 2px 4px;
  border-radius: 5px;
  font-size: 0.9em;
  font-weight: bold;
`;

export const Container = styled.div`
  padding: ${SPACER.large};
  border: 5px solid ${primaryTheme.COLORS.error};
`;
